import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { ProductGridSlotConfig } from '@packages/common';

import { MultipleABTestConfiguration } from '../cookie/abTest';
import { AffinityMultiplierMap } from '../pageUtils/getDyAffinityFilters';

export type AppConfig = {
  abTestSetup: MultipleABTestConfiguration | null;
  affinitiesConfig: AffinityMultiplierMap | null;
  productGridSlotConfig: ProductGridSlotConfig | null;
};

const AFFINITIES_CONFIG_URL = getPublicRuntimeConfig('AFFINITIES_CONFIG_URL');
const PRODUCT_GRID_SLOT_CONFIGURATION = getPublicRuntimeConfig('PRODUCT_GRID_SLOT_CONFIGURATION');
const AB_TEST_CONFIG_URL = getPublicRuntimeConfig('AB_TEST_CONFIG_URL');

export async function getAppConfig(): Promise<AppConfig> {
  const [productGridSlotConfig, affinitiesConfig, abTestSetup] = await Promise.all<
    ProductGridSlotConfig | null,
    AffinityMultiplierMap | null,
    MultipleABTestConfiguration | null
  >([
    fetch(PRODUCT_GRID_SLOT_CONFIGURATION).then((res) => res.json()),
    fetch(AFFINITIES_CONFIG_URL).then((res) => res.json()),
    fetch(AB_TEST_CONFIG_URL).then((res) => res.json()),
  ]);

  return {
    abTestSetup,
    affinitiesConfig,
    productGridSlotConfig,
  };
}
